module.exports = __webpack_public_path__ + "img/guide_red.799ad217.jpg";